module.exports = __webpack_public_path__ + "static/img/6193_phase_function_Paper_PointsHejduk_Prediction.6c767ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6193_phase_function_Paper_PointsHejduk_Prediction.png
// module id = gxL3
// module chunks = 0